import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/WP.png";

export const wrestlePaloozaDetail = {
  wrestlepalooza: {
    id: "wrestlepalooza",
    title: "WrestlePalooza",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "wrestlepalooza",
        items: [
          {
            id: "wrestlepalooza-1",
            title: "WrestlePalooza",
            description: "Indianapolis 2025",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
